// qr-generator-org-picker — thin module-local wrapper around
// @jq4race/api-client's organization/location listing functions, mirroring
// the convention already established by ./qr-batches.ts: this module
// imports from its own `api/` folder rather than reaching into
// @jq4race/api-client directly from UI files.

import {
  listOrganizations as apiListOrganizations,
  listOrganizationLocationsAsSuperAdmin,
} from '@jq4race/api-client';
import type { ListLocationsResponse, ListOrganizationsResponse } from '@jq4race/shared';

export function listOrganizations(): Promise<ListOrganizationsResponse> {
  return apiListOrganizations();
}

/** Active locations for the given org — powers the dependent location select. */
export function listOrganizationLocations(orgId: string): Promise<ListLocationsResponse> {
  return listOrganizationLocationsAsSuperAdmin(orgId);
}
